import React, { useState } from 'react';
import { axiosInstance } from '../services/api';

const FONT_H = "'Lora', Georgia, serif";
const FONT_B = "'Source Sans 3', sans-serif";

export default function PublicDeleteAccount() {
  const [email, setEmail] = useState('');
  const [note, setNote] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    try {
      await axiosInstance.post('/account/deletion/public-request/', { email: email.trim(), note: note.trim() });
    } catch (e) {}
    setSubmitted(true);
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F5F5DC', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 480, width: '100%' }}>
        {/* Header */}
        <div style={{ background: '#556B2F', borderRadius: '16px 16px 0 0', padding: '24px 28px', textAlign: 'center', color: '#fff' }}>
          <h1 style={{ fontFamily: FONT_H, fontWeight: 700, fontSize: 24, margin: 0 }}>Delete Your 1G2N Account</h1>
        </div>

        <div style={{ background: '#fff', border: '1px solid #CCC', borderTop: 'none', borderRadius: '0 0 16px 16px', padding: '32px 28px' }}>
          {submitted ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#EDF3E0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 24 }}>
                ✉️
              </div>
              <h2 style={{ fontFamily: FONT_H, fontWeight: 700, fontSize: 22, color: '#2C2F26', marginBottom: 8 }}>Check your email</h2>
              <p style={{ fontSize: 16, color: '#5A6150', fontFamily: FONT_B, marginBottom: 16 }}>
                If an account exists with that email, we've sent instructions to close it. Check your inbox.
              </p>
              <div style={{ background: '#FBFBF3', border: '1px solid #EFEEE5', borderRadius: 10, padding: '12px 16px', textAlign: 'left' }}>
                <p style={{ fontSize: 14, color: '#828A76', fontFamily: FONT_B, margin: '0 0 4px' }}>Don't see it? Check your spam or junk folder.</p>
                <p style={{ fontSize: 14, color: '#828A76', fontFamily: FONT_B, margin: 0 }}>You can request again in an hour.</p>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p style={{ fontSize: 16, color: '#5A6150', fontFamily: FONT_B, marginBottom: 20 }}>
                Enter the email address associated with your account. We'll send you instructions to complete the deletion.
              </p>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontWeight: 700, fontSize: 15, color: '#2C2F26', marginBottom: 6, fontFamily: FONT_B }}>Email address</label>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  placeholder="you@example.com"
                  style={{ width: '100%', padding: '14px 16px', borderRadius: 10, border: '1.5px solid #E4E1D2', fontSize: 17, fontFamily: FONT_B, outline: 'none' }}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontWeight: 700, fontSize: 15, color: '#2C2F26', marginBottom: 6, fontFamily: FONT_B }}>Reason (optional)</label>
                <textarea
                  value={note} onChange={e => setNote(e.target.value)}
                  placeholder="Let us know why you'd like to delete your account..."
                  rows={3}
                  style={{ width: '100%', padding: '12px 16px', borderRadius: 10, border: '1.5px solid #E4E1D2', fontSize: 15, fontFamily: FONT_B, outline: 'none', resize: 'vertical' }}
                />
              </div>
              <button type="submit" disabled={!email.trim() || loading} style={{
                width: '100%', background: email.trim() && !loading ? '#556B2F' : '#E4E2D6',
                color: email.trim() && !loading ? '#fff' : '#A7A996',
                fontWeight: 700, fontSize: 17, padding: '16px', borderRadius: 12, border: 'none',
                cursor: email.trim() && !loading ? 'pointer' : 'not-allowed', fontFamily: FONT_B, minHeight: 56,
              }}>
                {loading ? 'Submitting...' : 'Submit request'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
